/**
 * Shared "non-site activity summary" page behavior: populates the Beaver
 * Builder back-link placeholder and initializes DataTables on the records
 * table. Used by every non-site/summary page listing table
 * (Activity 3 Summary, Non-Site Observations).
 *
 * @param {jQuery} $
 * @param {Object} options
 * @param {Object|null|undefined} options.back_link { url, text }, or falsy to hide the placeholder.
 * @param {Object} options.table_settings { default_page_size, page_size_label }.
 * @param {number} [options.actions_col] 0-based column index to leave unsortable (default 0).
 */
module.exports = function init_nonsite_summary_table($, options) {
  options = options || {};

  // Populate the BB back link placeholder if present.
  const $backlink_el = $('#site-year-summary-backlink');
  if ($backlink_el.length) {
    const back = options.back_link;
    if (back && back.url && back.text) {
      $backlink_el.html('<a href="' + back.url + '" class="mlmp-back-link">&larr; ' + back.text + '</a>');
    } else {
      $backlink_el.hide();
    }
  }

  // ── DataTables ─────────────────────────────────────────────────────────────
  const $table = $('.records-table');
  if ($table.length && typeof $.fn.DataTable !== 'undefined') {
    const settings = options.table_settings || {};
    const page_size = parseInt(settings.default_page_size || 10, 10);
    const size_label = (settings.page_size_label || 'Page Size') + ': _MENU_';
    const sizes = [5, 10, 20, 50, 100, 200, 500, 1000];
    const actions_col = options.actions_col ?? 0;

    $table.DataTable({
      paging: true,
      pageLength: page_size,
      lengthMenu: [sizes, sizes],
      info: false,
      searching: false,
      ordering: true,
      dom: '<"records-table-top"lp>t',
      language: {
        lengthMenu: size_label,
      },
      order: [[1, 'desc']], // default sort: Date descending
      columnDefs: [
        { orderable: false, targets: actions_col },
      ],
    });
  }
};
